module.exports = __webpack_public_path__ + "img/ledger-city-faq.4d8f4376.png";